import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
	providedIn: 'root',
})
export class AuthGuard  {
	constructor(private authService: AuthService, private translate: TranslocoService, private router: Router) { }

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): boolean {
		if (this.authService.loggedIn()) return true;
		else {
			this.router.navigate([this.translate.getActiveLang() + '/login']);
			return false;
		}
	}
}
